import { render, staticRenderFns } from "./expiredstock.vue?vue&type=template&id=234c359c&scoped=true&"
import script from "./expiredstock.vue?vue&type=script&lang=js&"
export * from "./expiredstock.vue?vue&type=script&lang=js&"
import style0 from "./expiredstock.vue?vue&type=style&index=0&id=234c359c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c359c",
  null
  
)

export default component.exports